import { stdObject } from "../data/types/stdObject";
import { applyDiscount } from "./applyDiscount";
import { toPrice } from "./toPrice";

export const recountTotals = ({
  tempData,
  index,
  key,
  type,
  value,
  params = {},
}: stdObject) => {
  let origin = tempData.items[index];
  origin[key + type] = key === "PRE" && params.blur ? toPrice(value) : value;

  const lineTotal = origin[`CAN${type}`] * origin[`PRE${type}`];
  origin[`TOT${type}`] = origin[`DES${type}`]
    ? applyDiscount(lineTotal, origin[`DES${type}`])
    : lineTotal;
  return tempData;
};
